
// export const apiUrl ="http://localhost:1025/";
// export const apiAsset ="http://localhost:1025/uploads/";

export const apiUrl ="https://api.bordarna.ir/api/";
export const apiAsset ="https://api.bordarna.ir/uploads/";
// export const apiAsset ="https://api.amirhosseinmofid.ir/uploads/";
